import { apiRequest } from "../api.js";

// 会员取消报名
export function getRuleCancle(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/cancel-sign";
  apiRequest(config);
}
// 非会员取消报名
export function getNoVipCancle(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/cancel-sign";
  apiRequest(config);
}

// 非会员表单确认预览
export function noVipSubmitCheck(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/check-sign-meeting";
  apiRequest(config);
}

// 会员表单确认预览
export function vipSubmitCheck(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/check-sign-meeting";
  apiRequest(config);
}

// 非会员报名成功提醒
export function getNoVipRulemsg(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/get-rule-message";
  apiRequest(config);
}

// 会员获取报名成功提醒
export function getRuleMessage(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/get-rule-message";
  apiRequest(config);
}

// 获取活动报名时间检验
export function checkTimeApi(config) {
  config.method = "post";
  config.url = "/meetingapi/meeting-out/check-time";
  apiRequest(config);
}

//会员获取报名人员详情
export function getVipApplyDetail(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/get-person-detail";
  apiRequest(config);
}

// 非会员获取报名人员详情
export function getNoVipApplyDetil(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/get-person-detail";
  apiRequest(config);
}

// 会员取消报名
export function checkSignVip(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/check-sign";
  apiRequest(config);
}

// 会员报名人员
export function getUserListVip(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/get-meeting-person";
  apiRequest(config);
}

// 确认报名-取消报名
export function checkSign(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/check-sign";
  apiRequest(config);
}

// 非会员报名人员列表
export function getUserList(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/get-meeting-person";
  apiRequest(config);
}

// 获取自定仪表单-会员
export function getFormVip(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/get-form";
  apiRequest(config);
}
// 提交自定义表单-会员
export function setFormVip(config) {
  config.method = "post";
  config.url = "/personapi/v1/meeting/sign-meeting";
  apiRequest(config);
}

// 获取自定义表单-非会员
export function getForm(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/get-form";
  apiRequest(config);
}
// 提交自定义表单-非会员
export function setFormNoVip(config) {
  config.method = "post";
  config.url = "/meetingapi/v1/meeting/sign-meeting";
  apiRequest(config);
}

//获取活动列表
export function getActivityList(config) {
  // config.method = 'post'
  // config.url = '/meetingapi/meeting-out/get-meeting-list'
  config.method = "get";
  config.url = "/app-api/person-meeting/meeting/get-list";
  apiRequest(config);
}

// 获取会议详情
export function getMeetingDetail(config) {
  config.method = "post";
  config.url = "/meetingapi/meeting-out/get-meeting-detail";
  apiRequest(config);
}

// 非个人会员登录
export function noMemberLogin(config) {
  config.method = "post";
  config.url = "/app-api/person/person-user/login";
  apiRequest(config);
}

//发送短信
export function sendPhoneMsg(config) {
  config.method = "post";
  config.url = "/app-api/person/person-user/send-sms";
  apiRequest(config);
}

//会议报道
export function signMeeting(config) {
  config.method = "post";
  config.url = "/meetingapi/sign/sign-meeting";
  apiRequest(config);
}

//会议签到
export function applyMeeting(config) {
  config.method = "post";
  config.url = "/meetingapi/sign/sign-rule";
  apiRequest(config);
}

